// @flow

import React, { useMemo } from "react";

import { MdClose } from "react-icons/md";
import { useModal } from "@quantum/ui";
import { Translate } from "@quantum/i18n";

import Draggable from "react-draggable";

import "./modal-sintaxe.css";

const ModalSintaxe = () => {
  const modal = useModal("sintaxe");
  const defaultPosition = useMemo(
    () => ({ x: window.innerWidth / 2 - 500 / 2, y: 100 }),
    []
  );

  return modal.isOpen ? (
    <Draggable handle=".ModalSintaxe__header" defaultPosition={defaultPosition}>
      <div className="ModalSintaxe">
        <div className="ModalSintaxe__header">
          <div>
            :: <Translate>compostas.sintaxe</Translate>
          </div>
          <div className="ModalSintaxe__header-fechar" onClick={modal.close}>
            <MdClose className="ModalSintaxe__close-icon" />
          </div>
        </div>
        <div className="ModalSintaxe__body">
          <div className="ModalSintaxe__mensagem">
            <Translate>configuracaoRelatorio.descricaoModalSintaxe</Translate>
          </div>
          <table className="ModalSintaxe__tabela-sinais">
            <thead>
              <tr className="linha-header">
                <th>
                  <Translate>configuracaoRelatorio.sintaxeSinais</Translate>
                </th>
                <th>
                  <Translate>configuracaoRelatorio.sintaxeDescricao</Translate>
                </th>
                <th>
                  <Translate>configuracaoRelatorio.sintaxeExemplo</Translate>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>.</td>
                <td>
                  <Translate>
                    configuracaoRelatorio.sintaxeSeparadorDecimal
                  </Translate>
                </td>
                <td>0.5</td>
              </tr>
              <tr>
                <td>,</td>
                <td>
                  <Translate>
                    configuracaoRelatorio.sintaxeSeparadorArgumentos
                  </Translate>
                </td>
                <td>QA, QB</td>
              </tr>
              <tr>
                <td>+</td>
                <td>
                  <Translate>configuracaoRelatorio.sintaxeAdicao</Translate>
                </td>
                <td>QA + QB</td>
              </tr>
              <tr>
                <td>-</td>
                <td>
                  <Translate>configuracaoRelatorio.sintaxeSubtracao</Translate>
                </td>
                <td>QA - QB</td>
              </tr>
              <tr>
                <td>*</td>
                <td>
                  <Translate>
                    configuracaoRelatorio.sintaxeMultiplicacao
                  </Translate>
                </td>
                <td>QA * QB</td>
              </tr>
              <tr>
                <td>/</td>
                <td>
                  <Translate>configuracaoRelatorio.sintaxeDivisao</Translate>
                </td>
                <td>QA/QB</td>
              </tr>
              <tr>
                <td>^</td>
                <td>
                  <Translate>
                    configuracaoRelatorio.sintaxeExponenciacao
                  </Translate>
                </td>
                <td>QA ^ QB</td>
              </tr>
              <tr>
                <td>!</td>
                <td>
                  <Translate>configuracaoRelatorio.sintaxeFatorial</Translate>
                </td>
                <td>QA!</td>
              </tr>
              <tr>
                <td>#</td>
                <td>
                  <Translate>configuracaoRelatorio.sintaxeModulo</Translate>
                </td>
                <td>QA # QB</td>
              </tr>
            </tbody>
          </table>
          <table className="ModalSintaxe__tabela-sinais">
            <thead>
              <tr className="linha-header">
                <th colSpan={3}>
                  <Translate>configuracaoRelatorio.sintaxeAvancadas</Translate>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>iff</td>
                <td>
                  <Translate>configuracaoRelatorio.sintaxeSe</Translate>
                </td>
                <td>iff(QA = 1, 1; QA = 2, 2)</td>
              </tr>
              <tr>
                <td>min</td>
                <td>
                  <Translate>configuracaoRelatorio.sintaxeMinimo</Translate>
                </td>
                <td>min(QA, QB, QC)</td>
              </tr>
              <tr>
                <td>max</td>
                <td>
                  <Translate>configuracaoRelatorio.sintaxeMaximo</Translate>
                </td>
                <td>max(QA, QB, QC)</td>
              </tr>
              <tr>
                <td>add</td>
                <td>
                  <Translate>configuracaoRelatorio.sintaxeSoma</Translate>
                </td>
                <td>add(QA, QB, QC)</td>
              </tr>
              <tr>
                <td>multi</td>
                <td>
                  <Translate>
                    configuracaoRelatorio.sintaxeMultiplicacao
                  </Translate>
                </td>
                <td>multi(QA, QB, QC)</td>
              </tr>
              <tr>
                <td>mean</td>
                <td>
                  <Translate>configuracaoRelatorio.sintaxeMedia</Translate>
                </td>
                <td>mean(QA, QB, QC)</td>
              </tr>
              <tr>
                <td>var</td>
                <td>
                  <Translate>configuracaoRelatorio.sintaxeVariancia</Translate>
                </td>
                <td>var(QA, QB, QC)</td>
              </tr>
              <tr>
                <td>std</td>
                <td>
                  <Translate>
                    configuracaoRelatorio.sintaxeDesvioPadrao
                  </Translate>
                </td>
                <td>std(QA, QB, QC)</td>
              </tr>
              <tr>
                <td>coalesce</td>
                <td>
                  <Translate>configuracaoRelatorio.sintaxeCoalesce</Translate>
                </td>
                <td>coalesce(QA, QB, 0)</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </Draggable>
  ) : null;
};

export default ModalSintaxe;
